var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 379.356,
    viewBox: "0 0 800 379.356",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-400 -159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H159.657a4.094,4.094,0,0,1,4.094,4.094v100.98a4.094,4.094,0,0,1-4.094,4.094H4.094A4.094,4.094,0,0,1,0,105.073V4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(400 159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,1.365A2.732,2.732,0,0,0,1.365,4.094v100.98A2.732,2.732,0,0,0,4.094,107.8H159.657a2.732,2.732,0,0,0,2.729-2.729V4.094a2.732,2.732,0,0,0-2.729-2.729H4.094M4.094,0H159.657a4.094,4.094,0,0,1,4.094,4.094v100.98a4.094,4.094,0,0,1-4.094,4.094H4.094A4.094,4.094,0,0,1,0,105.073V4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(400 159)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.729,0H158.292a2.729,2.729,0,0,1,2.729,2.729V16.375H0V2.729A2.729,2.729,0,0,1,2.729,0Z",
    transform: "translate(401.365 160.365)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(416.375 193.115)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(468.229 193.115)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(416.375 217.677)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(468.229 217.677)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(416.375 242.24)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(468.229 242.24)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(678.376 160.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 156,
    rx: 6,
    transform: "translate(0.624 -0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,1.308A2.677,2.677,0,0,0,1.365,3.923V153a2.677,2.677,0,0,0,2.729,2.615H159.657A2.677,2.677,0,0,0,162.386,153V3.923a2.677,2.677,0,0,0-2.729-2.615H4.094M4.094,0H159.657a4.011,4.011,0,0,1,4.094,3.923V153a4.011,4.011,0,0,1-4.094,3.923H4.094A4.011,4.011,0,0,1,0,153V3.923A4.011,4.011,0,0,1,4.094,0Z",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.729,0H158.292a2.729,2.729,0,0,1,2.729,2.729V16.375H0V2.729A2.729,2.729,0,0,1,2.729,0Z",
    transform: "translate(1.365 1.365)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.375 34.115)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.229 34.115)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.375 58.677)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.229 58.677)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.375 83.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.229 83.24)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.375 107.803)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.229 107.803)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.375 132.365)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.229 132.365)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 158,
    rx: 6,
    transform: "translate(498 380.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,1.308A2.677,2.677,0,0,0,1.365,3.923V153a2.677,2.677,0,0,0,2.729,2.615H159.657A2.677,2.677,0,0,0,162.386,153V3.923a2.677,2.677,0,0,0-2.729-2.615H4.094M4.094,0H159.657a4.011,4.011,0,0,1,4.094,3.923V153a4.011,4.011,0,0,1-4.094,3.923H4.094A4.011,4.011,0,0,1,0,153V3.923A4.011,4.011,0,0,1,4.094,0Z",
    transform: "translate(498.25 381.428)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.729,0H158.292a2.729,2.729,0,0,1,2.729,2.729V16.375H0V2.729A2.729,2.729,0,0,1,2.729,0Z",
    transform: "translate(499.615 382.793)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(514.625 415.543)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(566.48 415.543)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(514.625 440.105)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(566.48 440.105)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(514.625 464.668)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(566.48 464.668)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(514.625 489.231)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(566.48 489.231)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(514.625 513.793)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(566.48 513.793)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H159.657a4.094,4.094,0,0,1,4.094,4.094v100.98a4.094,4.094,0,0,1-4.094,4.094H4.094A4.094,4.094,0,0,1,0,105.073V4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(857.137 373.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,1.365A2.732,2.732,0,0,0,1.365,4.094v100.98A2.732,2.732,0,0,0,4.094,107.8H159.657a2.732,2.732,0,0,0,2.729-2.729V4.094a2.732,2.732,0,0,0-2.729-2.729H4.094M4.094,0H159.657a4.094,4.094,0,0,1,4.094,4.094v100.98a4.094,4.094,0,0,1-4.094,4.094H4.094A4.094,4.094,0,0,1,0,105.073V4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(857.137 373.923)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.729,0H158.292a2.729,2.729,0,0,1,2.729,2.729V16.375H0V2.729A2.729,2.729,0,0,1,2.729,0Z",
    transform: "translate(858.502 375.287)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(873.512 408.038)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(925.367 408.038)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(873.512 432.6)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(925.367 432.6)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(873.512 457.163)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(925.367 457.163)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.005,104.731h5.472V51.338H1.027A1.026,1.026,0,0,1,0,50.313V1.028a1.026,1.026,0,1,1,2.052,0V49.284H99.5a1.029,1.029,0,0,1,1.027,1.028v54.418H106L99.5,115Z",
    transform: "translate(481 267.356)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6,10.191,0V5.052H195.982A.987.987,0,0,1,197,6a.985.985,0,0,1-1.018.947H10.191V12Z",
    transform: "translate(661 430.356)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.945,140.983V7.474H10.275V12.91L0,6.454,10.275,0V5.434h88.7A1.025,1.025,0,0,1,100,6.454V140.983a1.028,1.028,0,0,1-2.055,0Z",
    transform: "translate(841 232.356)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035.833 160.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 156,
    rx: 6,
    transform: "translate(0.167 -0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,1.308A2.677,2.677,0,0,0,1.365,3.923V153a2.677,2.677,0,0,0,2.729,2.615H159.657A2.677,2.677,0,0,0,162.386,153V3.923a2.677,2.677,0,0,0-2.729-2.615H4.094M4.094,0H159.657a4.011,4.011,0,0,1,4.094,3.923V153a4.011,4.011,0,0,1-4.094,3.923H4.094A4.011,4.011,0,0,1,0,153V3.923A4.011,4.011,0,0,1,4.094,0Z",
    transform: "translate(0.065)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.729,0H158.292a2.729,2.729,0,0,1,2.729,2.729V16.375H0V2.729A2.729,2.729,0,0,1,2.729,0Z",
    transform: "translate(1.43 1.365)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.44 34.115)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.295 34.115)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.44 58.677)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.295 58.677)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.44 83.24)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.295 83.24)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.44 107.803)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.295 107.803)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H31.386a4.094,4.094,0,1,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(16.44 132.365)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,0H77.782a4.094,4.094,0,0,1,0,8.188H4.094A4.094,4.094,0,0,1,4.094,0Z",
    transform: "translate(68.295 132.365)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1019.167 316.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.477,119.948A1.023,1.023,0,0,1-1.5,118.925V-.477A1.023,1.023,0,0,1-.477-1.5,1.023,1.023,0,0,1,.547-.477v119.4A1.023,1.023,0,0,1-.477,119.948Z",
    transform: "translate(99.425 1.5)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.68.547H-.477A1.023,1.023,0,0,1-1.5-.477,1.023,1.023,0,0,1-.477-1.5H93.68A1.023,1.023,0,0,1,94.7-.477,1.023,1.023,0,0,1,93.68.547Z",
    transform: "translate(5.268 120.902)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0,13,10H0Z",
    transform: "translate(-0.167 126.746) rotate(-90)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.a16326f1c24bea8e95abea7c3056844d.svg";
export { ForwardRef as ReactComponent };